import { Component, Output, EventEmitter, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CONSTANTS_TOKEN } from '../../config';
import { PortalService, UtilsService } from '../../services';
import { IconSizeClass } from '../../enums';
import { Router } from '@angular/router';

@Component({
  selector: 'educare-learning-hub-viewer',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './learning-hub-viewer.component.html',
  styleUrls: ['./learning-hub-viewer.component.scss']
})
export class LearningHubViewerComponent implements OnInit {
  @Output() back = new EventEmitter<void>();

  axonifyUrl: SafeResourceUrl | null = null;

  constructor(
    @Inject(CONSTANTS_TOKEN) private constants: any,
    private utils: UtilsService,
    private sanitizer: DomSanitizer,
    private portalService: PortalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadAxonify();
  }

  loadAxonify() {
    this.utils.spin.show();
    const axonifyEndpoint = this.constants.api.privateEndpoints.axonifySso;
    this.portalService.get(this.utils.getEncryptedUrls(axonifyEndpoint)).subscribe({
      next: (response: any) => {
        const decodedUrl = atob(response.data.secureUrl);
        this.axonifyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(decodedUrl);
        this.utils.spin.hide();
      },
      error: () => {
        this.utils.spin.hide();
        this.utils.openConfirmationDialog(
          {
            icon: 'das-access-reject',
            title: this.utils.translation('messages.learningHub.errorMessages'),
            description: this.utils.translation('messages.learningHub.errorMessage'),
            cancelButtonText: this.utils.translation('messages.learningHub.close'),
            iconSize: IconSizeClass.Large,
            action: () => {
              this.onBack();
            }
          },
          '665px'
        );
      }
    });
  }

  onBack() {
    if (this.constants.app.portalType === 'admin') {
      this.router.navigate(['cme']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}
